import React from 'react';
import { RouteConfig } from 'react-router-config';

import { isIntranet } from '@/util/dev-tool';
import { PageRouteType, routePostProc } from '@/util/route';

const Product = React.lazy(() => import('@/page/app/system/product'));

const SystemUser = React.lazy(() => import('@/page/app/system/system-user'));

const Audit = React.lazy(() => import('@/page/app/system/audit'));

const SecurityAuditLog = React.lazy(
  () => import('@/page/app/system/security-ticket-audit')
);
// 增加h5配置
const Sandbox = React.lazy(() => import('@/page/app/system/toc-sandbox'));

const SYSTEM_ROUTE: RouteConfig[] = [
  {
    path: '/systemUser',
    component: SystemUser,
  },
  {
    path: '/product',
    component: Product,
  },
  {
    path: '/securityTicketAudit',
    component: SecurityAuditLog,
  },
  {
    path: '/sandbox',
    component: Sandbox,
  },
];

if (isIntranet()) {
  SYSTEM_ROUTE.push({
    path: '/audit',
    component: Audit,
  });
}

export { SYSTEM_ROUTE };
export default routePostProc(PageRouteType.SYSTEM, SYSTEM_ROUTE);
